import { render, staticRenderFns } from "./ChangePasswordProfileForm.vue?vue&type=template&id=71458691&"
import script from "./ChangePasswordProfileForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports